<template>
  <div class="inclosure" v-if="pageShow">
    <div class="pb26 flex-row jcsb">
      <el-button type="primary" @click="addCourse">{{ $t("home.addTheCompany") }}</el-button>
      <el-form :inline="true" :model="searchForm" @keyup.enter.native="searchHandle">
        <el-form-item class="mb0">
          <el-input v-model="searchForm.businessNo" :placeholder="$t('home.orderNumber')" clearable></el-input>
        </el-form-item>
        <el-form-item class="mb0">
          <el-input v-model="searchForm.companyName" :placeholder="$t('home.companyName')" clearable></el-input>
        </el-form-item>
        <el-form-item class="mb0 mr0">
          <el-button type="primary" plain v-debounce icon="el-icon-search" @click="searchHandle">{{ $t("common.button.search") }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="tableWrap">
      <el-table
        :data="tableData"
        v-loading="tableLoading"
        style="width: 100%"
        :max-height="getTableHeight"
        header-cell-class-name="table-header"
        :default-sort="{ prop: 'createTime', order: 'descending' }"
        @sort-change="tableSortChange"
        :row-class-name="getRowClassName"
      >
        <!-- 内容为空或接口报错 -->
        <template slot="empty">
          <div class="pt100 pb80" v-if="tableErrType == 1">
            <div>
              <img src="@/assets/img/placeholder.png" alt="" />
            </div>
            <p class="fs16 black88">{{ $t("home.noData") }}</p>
            <div class="toCreation">
              <router-link to="/enroll/creation" class="fxRow">{{ $t("home.toCreation") }}</router-link>
            </div>
          </div>
          <placeholder v-if="tableErrType == 2"></placeholder>
        </template>
        <!-- 内容为空或接口报错 -->

        <!-- 展开 -->
        <el-table-column type="expand" width="30px">
          <template slot-scope="props">
            <Expand :adjustmentList="props.row.adjustmentList || []" />
          </template>
        </el-table-column>

        <el-table-column prop="applymentNo" :label="$t('home.orderNumber')" align="center" width="140px"></el-table-column>
        <el-table-column prop="createTime" :label="$t('home.tradeDate')" align="center" min-width="130px" sortable="custom"></el-table-column>
        <el-table-column prop="country" :label="$t('home.country')" align="center" min-width="170px"></el-table-column>
        <el-table-column :label="$t('home.combo')" align="center" min-width="160px">
          <template slot-scope="scope">
            <template v-if="scope.row.businessType == 'COMPREHENSIVE_CUSTOMIZED'">
              <p>{{ $t("enroll.quotation.comprehensiveTitle") }}</p>
            </template>
            <template v-else-if="scope.row.businessType == 'FUND_ADMIN_CUSTOMIZED'">
              <p>{{ $t("enroll.quotation.fundAdminTitle") }}</p>
            </template>
            <template v-else>
              <template v-if="scope.row.goodsListType == 1">
                <div v-for="item in scope.row.goodsList" :key="`package-${scope.row.id}-${item.productId}`">
                  <p v-if="item.package">
                    {{ getLanguage == "zh" ? item.package.packageNameCn : item.package.packageName }}
                  </p>
                </div>
              </template>
              <template v-if="scope.row.goodsListType == 2">
                <div v-for="item in scope.row.goodsList" :key="`service-${scope.row.id}-${item.productId}`">
                  <p v-if="item.service">
                    {{ getLanguage == "zh" ? item.service.descriptionCn : item.service.description }}
                  </p>
                </div>
              </template>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="applicantName" :label="$t('home.proposer')" align="center" min-width="120px"></el-table-column>
        <el-table-column :label="$t('home.companyName')" align="center" min-width="180px">
          <template slot-scope="scope">
            <template v-if="scope.row.businessType == 'COMPANY_INCORPORATION'">
              <p>{{ scope.row.proposedCompanyName1 }}</p>
              <p>{{ scope.row.proposedCompanyName2 }}</p>
              <p>{{ scope.row.proposedCompanyName3 }}</p>
            </template>
            <p v-if="scope.row.businessType == 'SERVICE_TRANSFER' || scope.row.businessType == 'COMPREHENSIVE_CUSTOMIZED'">
              {{ scope.row.questionnaire ? scope.row.questionnaire.proposedCompanyName : "" }}
            </p>
            <template v-if="scope.row.businessType == 'FUND_ADMIN_CUSTOMIZED' && scope.row.fundInfoList">
              <p v-for="alone in scope.row.fundInfoList" :key="`fundInfo${alone.id}`">
                {{ alone.fundName }}
              </p>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="applymentStatus" :label="$t('home.applicationStatus')" align="center" min-width="120px" sortable="custom">
          <template slot-scope="scope">
            <p>{{ getGlobalLabel("applymentStatusList", scope.row.applymentStatus) }}</p>
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('common.operation')" width="136px">
          <template slot-scope="scope">
            <!-- 查看 -->
            <el-button type="text" icon="el-icon-view" @click="viewDetails(scope.row)">{{ $t("home.viewDetails") }}</el-button>
            <!-- 填写资料 -->
            <el-button type="text" icon="el-icon-edit" @click="fillInfor(scope.row)" v-if="canEditOrDelete(scope.row.applymentStatus)">
              {{ $t("home.fillInfor") }}
            </el-button>
            <!-- 重传资料 -->
            <el-button type="text" icon="el-icon-upload2" @click="anewInfor(scope.row)" v-if="scope.row.applymentStatus == 'REJECTED'">
              {{ $t("home.anewInfor") }}
            </el-button>
            <!-- 待支付 / 订单列表 -->
            <el-button type="text" icon="el-icon-tickets" @click="payment(scope.row)" v-if="paymentShow(scope.row)">
              {{ scope.row.hasUnpaidOrder ? $t("home.payment") : $t("home.orderList") }}
            </el-button>
            <!-- 删除 -->
            <el-button type="text" icon="el-icon-delete" class="red" @click="remove(scope.row)" v-if="canEditOrDelete(scope.row.applymentStatus)">
              {{ $t("home.delete") }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="tar pt26">
      <!-- 分页 -->
      <el-pagination
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
        :current-page="current"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :total="totalCount"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { getAction, postAction } from "@/api/common";
import Placeholder from "@/components/Placeholder/index";
import Expand from "./components/Expand";
import { tableHeight } from "@/utils/common";
import paginationMixin from "@/mixins/paginationMixin";
import tableMixin from "@/mixins/tableMixin";
import { mapGetters } from "vuex";
export default {
  name: "Home",
  mixins: [paginationMixin, tableMixin],
  components: {
    Placeholder,
    Expand,
  },
  data() {
    return {
      getTableHeight: tableHeight(294), // 表格高度
      searchForm: {
        businessNo: "",
        companyName: "",
      },
      dataForm: {
        businessNo: "",
        companyName: "",
        "orders[0].asc": false,
        "orders[0].column": "t1.id",
      },
      tableLoading: false, // table的loading
      tableData: [], // table数据
      pageShow: false,
      pageOrigin: null,
      tableErrType: 1, // 1 没有数据, 2 接口出错
    };
  },
  computed: {
    ...mapGetters("language", ["getLanguage"]),
    ...mapGetters("constant", ["getApplyStepList", "getGlobalLabel"]),
  },
  methods: {
    // 判断表格行是否可以展开
    getRowClassName({ row }) {
      const list = row.adjustmentList;
      if (!list || list.length === 0) {
        return "hide-expand";
      }
      return "";
    },
    // 可以编辑(填写资料)或删除
    canEditOrDelete(status) {
      const allowStatus = ["DRAFT", "INQUIRING", "QUOTING", "QUOTATION_AUDITING", "QUOTATION_AUDIT_PASS", "QUOTATION_AUDIT_FAIL"];
      return allowStatus.includes(status);
    },
    // 搜索
    searchHandle() {
      const searchForm = { ...this.searchForm };
      const { businessNo, companyName } = searchForm;
      this.dataForm.businessNo = businessNo;
      this.dataForm.companyName = companyName;
      this.getDataList(1);
    },
    // 获取列表数据
    getDataList(current) {
      this.tableLoading = true;
      if (current) {
        this.current = current;
      }
      const params = {
        current: this.current,
        size: this.pageSize,
        ...this.dataForm,
      };
      getAction("/companyApplyment/paging", params)
        .then(res => {
          const resData = res.data;
          this.tableData = resData.records;
          this.totalCount = resData.total;
          // 列表为空并且是从登录页过来时，直接跳转步骤0
          if (resData?.records?.length == 0 && this.pageOrigin == "/login") {
            this.$router.push("/enroll/creation");
          }
          // 通过搜索返回空数组，展示无数据的placehold
          if (params.businessNo || params.companyName) {
            this.tableErrType = 2;
          } else {
            this.tableErrType = 1;
          }
        })
        .catch(err => {
          this.tableErrType = 2;
        })
        .finally(() => {
          this.pageShow = true;
          this.tableLoading = false;
        });
    },
    // 查看详情
    viewDetails(row) {
      this.$router.push({
        path: "/enroll/details",
        query: {
          id: row.id,
        },
      });
    },
    // 填写资料
    fillInfor(row) {
      const { country, businessType, isLaterService, lastStayPage } = row;
      const currentSteps = this.getApplyStepList(country, businessType, isLaterService);
      const path = currentSteps[lastStayPage ? lastStayPage - 1 : 0]?.currentPath;
      this.$router.push({
        path,
        query: {
          id: row.id,
        },
      });
    },
    // 重传资料
    anewInfor(row) {
      this.$router.push({
        path: "/enroll/upload",
        query: {
          id: row.id,
          again: 1,
        },
      });
    },
    // 判断是否显示 订单列表/去支付
    paymentShow(row) {
      // 不支持支付的申请状态
      const notSupportPayApplymentStatus = ["DRAFT", "INQUIRING", "QUOTING", "QUOTATION_AUDITING", "QUOTATION_AUDIT_PASS", "QUOTATION_AUDIT_FAIL", "FORFEITED"];
      // 判断当前申请状态是否在支持的申请状态列表中
      return !notSupportPayApplymentStatus.includes(row.applymentStatus);
    },
    // 订单列表/去支付
    payment(row) {
      this.$router.push({
        path: "/enroll/notPaid",
        query: {
          applymentId: row.id,
        },
      });
    },
    // 新建注册公司（步骤0）
    addCourse() {
      this.$router.push("/enroll/creation");
    },
    // 删除
    remove(row) {
      this.$confirm(this.$t("common.hint.remove"), this.$t("common.hint.title"), {
        type: "warning",
      })
        .then(() => {
          postAction(`/companyApplyment/${row.id}/delete`, {})
            .then(res => {
              this.$message({
                message: this.$t("common.success.remove"),
                type: "success",
                duration: 1000,
                onClose: () => {
                  // mixins
                  this.singleDataDelete();
                  // 获取列表数据
                  this.getDataList();
                },
              });
            })
            .catch(err => {});
        })
        .catch(() => {});
    },
  },
  activated() {
    // 还原搜索数据
    const { businessNo, companyName } = { ...this.dataForm };
    this.$set(this.searchForm, "businessNo", businessNo);
    this.$set(this.searchForm, "companyName", companyName);
    // 获取列表数据
    this.getDataList();
  },
  beforeRouteEnter(to, from, next) {
    // 判断页面来源
    next(vm => {
      vm.pageOrigin = from.path || null;
    });
  },
};
</script>

<style lang="scss" scoped>
.searchWrap {
  ::v-deep {
    .el-form-item__label {
      height: 38px;
      line-height: 16px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }

    .el-input__inner {
      height: 38px;
      line-height: 38px;
    }

    .el-date-editor .el-range-separator {
      line-height: 29px;
      width: 7%;
    }

    .el-date-editor .el-range__icon {
      line-height: 30px;
    }

    .el-date-editor .el-range__close-icon {
      line-height: 29px;
      width: 16px;
      margin-right: -4px;
      padding-left: 4px;
    }
  }
}

.tableWrap {
  ::v-deep {
    .iconfont {
      font-size: 14px;
      line-height: 1;
      margin-right: 3px;
    }
    .el-button + .el-button {
      margin-left: 0 !important;
    }

    .el-button {
      padding: 10px !important;
    }

    .hide-expand {
      .el-table__expand-column {
        pointer-events: none;
        .el-table__expand-icon {
          display: none;
        }
      }
    }
  }
}

.toCreation {
  display: inline-block;
  height: 50px;
  background: #eceff9;
  border-radius: 6px;
  margin: 0 auto;

  a {
    padding: 0 40px;
    height: 100%;
    line-height: 50px;
    font-size: 18px;
    font-weight: bold;
    color: #0060ff;
  }
}
</style>
